import { gql } from '@apollo/client';

export const GET_AD_PERMITTED_TIMEZONES = gql`
  query GET_AD_PERMITTED_TIMEZONES {
    getAdPermittedTimezones
  }
`;
